module.exports = __webpack_public_path__ + "static/media/Header_Epargn.ed429dca.png";